// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2YxJj","emails":"CreateEditClinics_emails__297rP","emailTagLabel":"CreateEditClinics_emailTagLabel__JJ7FY"};